import React, {useState, useEffect} from 'react'
import { Image } from 'react-bootstrap'
import fade from "../../../../assets/build/fade.png"

import "../buidl.css";


function Bannermockup2() {

   const [isSmallScreen, setIsSmallScreen] = useState(window.innerWidth <= 768);
  
    useEffect(() => {
      const handleResize = () => {
        setIsSmallScreen(window.innerWidth <= 768);
      };
  
      window.addEventListener('resize', handleResize);
  
      return () => {
        window.removeEventListener('resize', handleResize);
      };
    }, []);

    const handleContextMenu = (e) => {
      e.preventDefault(); // Disable right-click
    };


  return (
    <div 
    fluid 
    className='container-section' 
    style={{
      backgroundColor:"#292929",
      padding: 0,
      display: 'flex', 
      justifyContent: 'center', 
      alignItems: 'center', 
      height: isSmallScreen ? 'auto' : '100vh'
      }}>
       <Image src={fade} alt='fade'  width="100%" draggable="false" onContextMenu={handleContextMenu}  height="auto" />
    </div>
    
     
    
  )
}

export default Bannermockup2